import { Link } from "react-router-dom";
import {
  Show,
  SignInButton,
  SignUpButton,
  UserButton,
} from "@clerk/react";

const links = [
  { href: "#features", label: "Features" },
  { href: "#how", label: "How it works" },
  { href: "#pricing", label: "Pricing" },
];

export function Navbar() {
  return (
    <header className="fixed top-0 right-0 left-0 z-50 border-b border-white/[0.06] bg-[#030303]/70 backdrop-blur-xl">
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 font-semibold tracking-tight">
          <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-orange-500 text-xs font-bold text-white">
            OG
          </span>
          <span className="hidden sm:inline">OpenGateway</span>
        </Link>
        <nav className="hidden items-center gap-6 text-sm text-white/60 md:flex">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="transition hover:text-white">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Show when="signed-out">
            <SignInButton mode="modal" forceRedirectUrl="/app">
              <button
                type="button"
                className="rounded-full px-3 py-1.5 text-sm text-white/70 transition hover:text-white"
              >
                Sign in
              </button>
            </SignInButton>
            <SignUpButton mode="modal" forceRedirectUrl="/app">
              <button
                type="button"
                className="rounded-full bg-white px-3.5 py-1.5 text-sm font-semibold text-zinc-900 transition hover:bg-orange-100"
              >
                Get started
              </button>
            </SignUpButton>
          </Show>
          <Show when="signed-in">
            <Link
              to="/app"
              className="rounded-full px-3 py-1.5 text-sm text-white/70 transition hover:text-white"
            >
              Dashboard
            </Link>
            <UserButton />
          </Show>
        </div>
      </div>
    </header>
  );
}
